import { ModelType } from '@biteinc/enums';

import { TimeHelper } from '../helpers/time_helper';
import { menuItemAffinityRunSchema } from './menu_item_affinity_run_schema';

app.MenuItemAffinityRun = app.AbstractModel.extend({
  ModelName: 'menuItemAffinityRun',
  Schema: menuItemAffinityRunSchema,
  Type: ModelType.MenuItemAffinityRun,

  displayName() {
    if (this.get('name')) {
      return this.get('name');
    }

    const generatedAt = this.get('generatedAt');
    const generatedAtText = generatedAt
      ? TimeHelper.displayDateFromTimestamp(generatedAt, app.location?.get('timezone'))
      : 'Unknown date';
    const statusText = this.get('status') || 'unknown';
    const uploadedRuleCount = this.get('uploadedRuleCount');
    const uploadedRuleCountText =
      uploadedRuleCount === undefined || uploadedRuleCount === null
        ? 'unknown rules'
        : `${uploadedRuleCount} rules`;
    const shortId = this.id ? this.id.slice(-6) : 'new';

    return `${generatedAtText} - ${statusText} - ${uploadedRuleCountText} - #${shortId}`;
  },
});
